/**
 * GlobalRankTheme — Fetches the viewer's own travel stats once and applies
 * their rank colour to the entire app via RankThemeProvider.
 *
 * Mount this *inside* AuthContext at app root.
 */
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { RankThemeProvider } from "../contexts/RankThemeContext";
import { getRank } from "./ExplorerRank";

import { BACKEND_URL } from "../config/api";
const API = `${BACKEND_URL}/api`;
const TOTAL_COUNTRIES = 195;

export default function GlobalRankTheme({ user, children }) {
  const [rankName, setRankName] = useState(null);

  const useRankTheme = user?.preferences?.use_rank_theme !== false; // default ON

  const fetchStats = useCallback(async () => {
    if (!user) { setRankName(null); return; }
    try {
      const res = await axios.get(`${API}/items`);
      const items = res.data?.items || res.data || [];
      const countryCodes = new Set();
      for (const it of items) {
        if (it.completed && it.country_code) countryCodes.add(it.country_code);
      }
      const pct = (countryCodes.size / TOTAL_COUNTRIES) * 100;
      const rank = getRank(pct);
      setRankName(rank?.name || null);
    } catch {
      setRankName(null);
    }
  }, [user]);

  useEffect(() => { fetchStats(); }, [fetchStats]);

  // Refetch when user's premium / stats might change
  useEffect(() => {
    const handler = () => fetchStats();
    window.addEventListener("duolyst:stats-updated", handler);
    return () => window.removeEventListener("duolyst:stats-updated", handler);
  }, [fetchStats]);

  return (
    <RankThemeProvider rankName={rankName} useRankTheme={useRankTheme}>
      {children}
    </RankThemeProvider>
  );
}
